"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParserDependencies = void 0;

var _dependenciesEvaluateGenerated = require("./dependenciesEvaluate.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var ParserDependencies = {
  evaluateDependencies: _dependenciesEvaluateGenerated.evaluateDependencies,
  createParserClass: _factoriesAny.createParserClass
};
exports.ParserDependencies = ParserDependencies;